import { render } from "./PublicationView.vue?vue&type=template&id=61fda5dc"
import script from "./PublicationView.vue?vue&type=script&lang=js"
export * from "./PublicationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__